import React from "react"
import client_logo_1 from "../../images/about/client_logo/5kcar.png"
import client_logo_2 from "../../images/about/client_logo/tata.png"
import client_logo_3 from "../../images/about/client_logo/saatva.png"
import client_logo_4 from "../../images/about/client_logo/amazon.png"
import client_logo_5 from "../../images/about/client_logo/hdfc.png"
import client_logo_6 from "../../images/about/client_logo/hyundai.png"
import client_logo_7 from "../../images/about/client_logo/indian_terrain.png"
import client_logo_8 from "../../images/about/client_logo/crocs.png"
import client_logo_9 from "../../images/about/client_logo/grand_world.png"
import client_logo_10 from "../../images/about/client_logo/reliance.png"
import client_logo_11 from "../../images/about/client_logo/green_trends.png"
import client_logo_12 from "../../images/about/client_logo/stanza_living.png"
import client_logo_13 from "../../images/about/client_logo/lenskart.png"
import client_logo_14 from "../../images/about/client_logo/zolo.png"
import client_logo_15 from "../../images/about/client_logo/srivari.png"
import client_logo_16 from "../../images/about/client_logo/specsmakers.png"
import client_logo_17 from "../../images/about/client_logo/kgtown.png"
import client_logo_18 from "../../images/about/client_logo/saatva_1.png"
import client_logo_19 from "../../images/about/client_logo/vascon.png"

function Clients (){

    const Clients = [
    {
        src:client_logo_1,
        alt:"Client_logo"
    },
    {
        src:client_logo_2,
        alt:"Client_logo"
    },
    {
        src:client_logo_3,
        alt:"Client_logo"
    },
    {
        src:client_logo_4,
        alt:"Client_logo"
    },
    {
        src:client_logo_5,
        alt:"Client_logo"
    },
    {
        src:client_logo_6,
        alt:"Client_logo"
    },
    {
        src:client_logo_7,
        alt:"Client_logo"
    },
    {
        src:client_logo_8,
        alt:"Client_logo"
    },
    {
        src:client_logo_9,
        alt:"Client_logo"
    },
    {
        src:client_logo_10,
        alt:"Client_logo"
    },
    {
        src:client_logo_11,
        alt:"Client_logo"
    },
    {
        src:client_logo_12,
        alt:"Client_logo"
    },
    {
        src:client_logo_13,
        alt:"Client_logo"
    },
    {
        src:client_logo_14,
        alt:"Client_logo"
    },
    {
        src:client_logo_15,
        alt:"Client_logo"
    },
    {
        src:client_logo_16,
        alt:"Client_logo"
    },
    {
        src:client_logo_17,
        alt:"Client_logo"
    },
    {
        src:client_logo_18,
        alt:"Client_logo"
    },
    {
        src:client_logo_19,
        alt:"Client_logo"
    },

]

    return (
        <div className="max-w-[1196px] mx-auto my-[120px] px-6">
            <h1 className='heading !font-noto'>Our Clients</h1>
            <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]'/>

            <div className="grid grid-cols-4 gap-x-[35px] gap-y-[60px] mt-[60px] sm:grid-cols-7" >

               { Clients.map ((items)=>{

                return (
                    <img className="w-auto h-auto my-auto filter grayscale hover:grayscale-0" src={items.src} alt={items.alt}  data-aos="fade-up" data-aos-duration="800"  data-aos-anchor-placement="bottom-bottom"/>
                )
               })}

            </div>
        </div>
    )
}


export default Clients